import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.HostV2}/${EndPoint.CustomerSupportChat}`;

export async function getCustomerSupportChat(data) {
  return await Client.get(`${endpoint}`, data, true);
}

export async function getCustomerSupportChatCount(data) {
  return await Client.get(`${endpoint}/count`, data, true);
}

export async function createCustomerSupportChat(data) {
  return await Client.post(`${endpoint}`, data, true);
}

export async function postCustomerSupportChatAutoReply(data) {
  return await Client.post(`${endpoint}/auto-reply`, data, true);
}
